import { createFormContext } from "@mantine/form";
import type { HtmlPage } from "htmlpage/types/html-page.model";

export const [HTMLPageFormProvider, useHTMLPageFormContext, useHTMLPageForm] =
  createFormContext<Omit<HtmlPage, "id">>();
